import { Component, OnInit, ViewChild, Injector, AfterViewInit } from "@angular/core";
import { AppComponentBase } from "../../services/AppComponentBase";
import { LoginResponse, LoginStatus, FacebookService, InitParams, FBPostComponent  } from 'ngx-facebook';
import { IFaceBookPost } from '../../model/socialMedia.request';
import * as moment from "moment";
import * as $ from "jquery";
import *  as html2canvas from 'html2canvas';  
import { Utils } from "../../utils";
import { ShareService, ShareProvider, ShareProviders } from "../../services/share.service";
import { SharedContentClient, SharedContent } from "../../api/DixApiClient";
import { WorkspaceServiceService } from "../../services/workspace-service.service";
declare var window: any;
declare var FB: any;


@Component({
    selector: "socialMediaTabContent",
    template: require('./socialMediaTab.component.html'),
    styles: [require('./socialMediaTab.component.css')]
})


export class socialMediaTabComponent extends AppComponentBase implements OnInit {

    public get providersWithPosts()
    {
        return this.shareService.shareProviders.filter(sp => this.shareService.lastPosts[sp] != null);
    }

    constructor(injector: Injector, protected faceBookService:FacebookService, protected sharedContentClient: SharedContentClient) {
        super(injector);
        this.shareService.updateLastPosts();
        
        //this.sharedContentClient.getLatestUserPostByProvider(email, 'facebook').t

    }

    private _lastPost: IFaceBookPost = { message: "", id: "", created_time: "", picture:"", shares:"",permalink_url:"" };
    public get lastPost (): IFaceBookPost {
        return this._lastPost;
    }
    public set lastPost ( value: IFaceBookPost ) {
        
        this._lastPost = value;
    }


    private _postToShowUrl: string = "https://www.facebook.com/20531316728/posts/10154009990506729/";
    public get postToShowUrl (): string {
        return this._postToShowUrl;
    }
    public set postToShowUrl ( value: string ) {
        this._postToShowUrl = value;
    }

    clickShowFullPost()
    {
        window.FB.XFBML.parse();
    }

    doPost()
    {
        this.workspace.socialMedia.doNewPost();
    }

    logToFacebook()
    {
        this.workspace.socialMedia.facebook_LoginWithOptions();
        this.postToShowUrl= "https://www.facebook.com/20531316728/posts/10154009990506729/"
    }

    ngOnInit() {

    }

    ngAfterViewInit(): void {

    }

    private _twitterLoggedIn: boolean = false;
    public get twitterLoggedIn (): boolean {
        return this._twitterLoggedIn;
    }
    public set twitterLoggedIn ( value: boolean ) {
        this._twitterLoggedIn = value;
    }

    private _instagramLoggedIn: boolean = false;
    public get instagramLoggedIn (): boolean {
        return this._instagramLoggedIn;
    }

    public set instagramLoggedIn ( value: boolean ) {
        this._instagramLoggedIn = value;
    }

    private _linkedinLoggedIn: boolean = false;
    public get linkedinLoggedIn (): boolean {
        return this._linkedinLoggedIn;
    }
    public set linkedinLoggedIn ( value: boolean ) {
        this._linkedinLoggedIn = value;
    }

    public clickNotificationStatic() {
        this.toastrHelper.showSuccess("title", "Static", true);
    }

    public clickNotificationFading() {
        this.toastrHelper.showSuccess("title", "Fading", false);
    }

    public share(provider: string) {
        this.shareService.shareWithSvg(provider, "Look at my trading chart on PremiereTrade trading platform");
    }

    public clickCustom() {
       // this.toastr.showCustom();
    }
}

